module.exports = "<block-ui>\n  <router-outlet></router-outlet>\n</block-ui>\n"